var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconViewsGridView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_views_grid_view",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "grid_view_FILL0_wght400_GRAD0_opsz48",
    d: "M6,17.458V6H17.458V17.458ZM6,31V19.542H17.458V31ZM19.542,17.458V6H31V17.458Zm0,13.542V19.542H31V31ZM8.083,15.375h7.292V8.083H8.083Zm13.542,0h7.292V8.083H21.625Zm0,13.542h7.292V21.625H21.625Zm-13.542,0h7.292V21.625H8.083ZM21.625,15.375ZM21.625,21.625ZM15.375,21.625ZM15.375,15.375Z",
    transform: "translate(-6 -6)",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewsGridView);
export default __webpack_public_path__ + "static/media/icon_views_grid_view.f263423fc3f524af3530404199252722.svg";
export { ForwardRef as ReactComponent };